import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./assets/stylesheets/index.css";
import { BrowserRouter } from "react-router-dom";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [],
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);
